<strong class="title">Meta Information</strong>
@if (gear()?.gear; as info) {
  <div class="info">
    <div>
      <strong>Name</strong>
      <span>{{ info.name }}</span>
    </div>
    <div>
      <strong>Author</strong>
      <span>{{ info.author }}</span>
    </div>
    <div>
      <strong>Maintainer</strong>
      <span>{{ info.maintainer }}</span>
    </div>
    <div>
      <strong>Version</strong>
      <span>{{ info.version }}</span>
    </div>
    <div>
      <strong>Source</strong>
      <a target="_blank" test-id="source-link" [href]="info.source | sanitizeurl">{{ info.source }}</a>
    </div>
    <div>
      <strong>URL</strong>
      <a target="_blank" test-id="url-link" [href]="info.url | sanitizeurl">{{ info.url }}</a>
    </div>
    <div>
      <strong>License</strong>
      <span>{{ info.license }}</span>
    </div>
  </div>
}
